import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { Sharer } from '#src/app/pages/petitionDetails/shared/types';

import {
	PetitionDetailsPageSharerInfo,
	type PetitionDetailsPageSharerInfoQuery,
	type PetitionDetailsPageSharerInfoQueryVariables,
} from './sharer.graphql';

export async function getSharer(id: string, { gql: { fetch } }: UtilityContext): Promise<Sharer | undefined> {
	const { data } = await fetch<PetitionDetailsPageSharerInfoQuery, PetitionDetailsPageSharerInfoQueryVariables>({
		query: PetitionDetailsPageSharerInfo,
		variables: { id },
		rejectOnError: false,
	});
	return data?.user || undefined;
}
